export function getPlanCalendarWeekStart(offset) {
  const now = new Date();
  const dayOfWeek = now.getDay();
  const daysToMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
  const monday = new Date(now);

  monday.setDate(now.getDate() - daysToMonday + offset * 7);
  monday.setHours(0, 0, 0, 0);

  return monday;
}

export function getPlanCalendarDays(offset) {
  const monday = getPlanCalendarWeekStart(offset);

  return Array.from({ length: 7 }, (_, i) => {
    const date = new Date(monday);
    date.setDate(monday.getDate() + i);
    return date;
  });
}

export function formatWeekBeginning(offset) {
  const monday = getPlanCalendarWeekStart(offset);
  const sunday = new Date(monday);
  sunday.setDate(monday.getDate() + 6);

  const fmt = (d) => d.toLocaleDateString("en-GB", { day: "numeric", month: "long" });
  return `${fmt(monday)} – ${fmt(sunday)}`;
}

export function getDateKey(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}